export default __webpack_public_path__ + "static/media/WeChatZhuJiao.c6201fff.jpeg";